import styles from './CohortRead.module.scss';

export interface CohortReadProps {
  title: string;
  text: string;
}

export const CohortRead = ({ title, text }: CohortReadProps) => (
  <div className={styles.root} data-clipboard-snapshot>
    <div className={styles.card}>
      <p className={styles.title}>{title}</p>
      <p className={styles.text}>{text}</p>
    </div>
  </div>
);
